module.exports = __webpack_public_path__ + "static/media/电器.09d874e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/dongfeng/faultDiagnosis/demo/image/电器.png
// module id = 1718
// module chunks = 174